import React from "react";
import Grid from "@material-ui/core/Grid";
import MaterialTable from "material-table";
import { stElemnt } from "../../../../St/Reviews/cStyle";
import { useRptAF } from "../../../../St/Reviews/UseStyle";
import { styleNo } from "../../ShareFunctionsPrint";
const BodyEn = (props) => {
  const cls = useRptAF();
  const { data } = props;

  const cellS = {
    padding: "0px 0px",
    textAlign: "-webkit-center",
    margin: "0px",
    whiteSpace: "normal",
    border: "solid 0.1px",
    fontSize: "0.9rem",
    width: "32%",
    fontFamily: "Amiri-Regular",
    fontWeight:"bold",
  };

  var columns = [
   { title: "Sr \n م", field: "no",cellStyle:styleNo },
    { title:"Item Code \n الصنف", field: "barcode" },
    { title: "Description \n الوصف", field: "symbol", cellStyle: cellS },
    { title: "Quantity \n الكمية ", field: "val1" },
    { title: "Unit \n الوحدة", field: "unit_name", },
    { title: "Unit Price \n السعر",field:"exchange_price", },
    { title: "Total Price \n  الإجمالي", field: "totBill" },
  ];

  return (
    <Grid item container className={cls.rootBdy}>
      <Grid item container //className={cls.rootBdyup}
      style={{paddingTop:"0.5rem" ,direction: "ltr",
        }}>
        <Grid container  item xs={12} >
          <MaterialTable
            style={{ boxShadow: "none" ,width:"100%",tableLayout:"fixed"}}
            options={{
              showTitle: false,
              toolbar: false,
              sorting: false,
              selection: false,
              searchFieldAlignment: "left",
              searchFieldVariant: "outlined",
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              pageSize: 5,
              paginationType: "stepped",
              showFirstLastPageButtons: false,
              headerStyle: {
                ...stElemnt.AF.header,
                backgroundColor: "#fff",
                fontWeight: "bold",
                paddingTop: "2px",
                paddingBottom:"2px",
                border: "solid 0px",
                border: "solid 0.1px",
              },
              paging: false,
              cellStyle: {
                ...stElemnt.AF.cell,
                padding: "0px 1px",
              },
            }}
            localization={{ body: { emptyDataSourceMessage: <h1></h1> } }}
            columns={columns.map(column=>({
              ...column,
              title:column.title.split("\n").map((line,index)=>(
                <div key={index}>{line}</div>
              )),
             
            }))}
            data={data}
          />
        </Grid>
      </Grid>
      
    </Grid>
  );
};

export default BodyEn;
